'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _RailCardOption = require('./RailCardOption.jsx');

var _RailCardOption2 = _interopRequireDefault(_RailCardOption);

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Email = function (_Component) {
  (0, _inherits3.default)(Email, _Component);

  function Email() {
    (0, _classCallCheck3.default)(this, Email);
    return (0, _possibleConstructorReturn3.default)(this, (Email.__proto__ || (0, _getPrototypeOf2.default)(Email)).apply(this, arguments));
  }

  (0, _createClass3.default)(Email, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          components = _props.components,
          shopOptions = _props.shopOptions;

      var railCardOptions = shopOptions.options.filter(function (option) {
        return option.optionType === 'RailCard';
      });
      var styleRailCard = (0, _emailStyleTools.containerStyles)(components, 'railcard');

      return _react2.default.createElement(
        'table',
        { style: _emailStyleTools.fullMinimal, 'data-component': 'RailCard-EMAIL_ROOT' },
        _react2.default.createElement(
          'tbody',
          null,
          (railCardOptions.length || null) && railCardOptions.map(function (railCardOption, i) {
            return _react2.default.createElement(
              'tr',
              { key: i },
              _react2.default.createElement(
                'td',
                { style: (0, _extends3.default)({}, styleRailCard) },
                _react2.default.createElement(_RailCardOption2.default, {
                  components: components,
                  option: railCardOption,
                  key: i
                })
              )
            );
          })
        )
      );
    }
  }]);
  return Email;
}(_react.Component);

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components,
    shopOptions: state.rendering.shopOptions
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(Email);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/RailCard/Email/Email.jsx
// module id = 1545
// module chunks = 0